import {
    CheckList,
    Comment,
    Document,
    Download,
    Email,
    FlightTask,
    Info,
    Lens,
    Library,
    Limitation,
    Notice,
    Passenger,
    Pilot,
    Report,
    ReportAdd,
    Route,
    Send,
    Service,
    Summary,
} from '../../icons';
import { AirportServiceAdapter } from './Adapters/AirportServiceAdapter';
import { CheckListAdapter } from './Adapters/CheckListAdapter';
import { DocumentAdapter } from './Adapters/DocumentAdapter';
import { LibraryAdapter } from './Adapters/LibraryAdapter';
import { LimitationAdapter } from './Adapters/LimitationAdapter';
import { MessengerAdapter } from './Adapters/MessengerAdapter';
import { NoticeAdapter } from './Adapters/NoticeAdapter';
import { ReportAdapter } from './Adapters/ReportAdapter';
import { SummaryDataAdapter } from './Adapters/SummaryDataAdapter';
import { TelegramAdapter } from './Adapters/TelegramAdapter';
import { ContentType } from '../AttachmentsPage/constants';
import { CrewTypes } from '../../service/constants';

export const ButtonType = {
    TASKS: 0,
    SHOW_TASK: 1,
    FLIGHT: 2,
    FLIGHT_INFO: 3,
    CREW: 4,
    PASSENGERS: 5,
    TELEGRAMS: 6,
    NOTAMS: 7,
    CHECK_LIST: 8,
    AIRPORT_SERVICE: 9,
    LIMITATIONS: 10,
    DOCUMENTS: 11,
    ADD_REPORT: 12,
    REPORTS: 13,
    LIBRARY: 14,
    SUMMARY_TASK: 15,
    GET_DATA: 16,
    SEND_DATA: 17,
    // Новый раздел добавляем В КОНЕЦ перечисления, чтобы не сместить числовые
    // значения существующих кнопок (они сохранены в state.partitions у пилотов).
    MESSAGES: 18,
};

export const sidebarButton = {
    [ButtonType.TASKS]: {
        label: 'labels.flightTasks',
        icon: FlightTask,
    },
    [ButtonType.SHOW_TASK]: {
        label: 'labels.taskTitle',
        icon: Lens,
        activeTask: true,
    },
    [ButtonType.FLIGHT]: {
        label: 'info',
        icon: Info,
        activeTask: true,
    },
    [ButtonType.FLIGHT_INFO]: {
        label: 'labels.flightLog',
        icon: Route,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF],
    },
    [ButtonType.CREW]: {
        label: 'labels.crew',
        icon: Pilot,
        activeTask: true,
    },
    [ButtonType.PASSENGERS]: {
        label: 'labels.passengerList',
        icon: Passenger,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_SALONSTAFF],
    },
    [ButtonType.TELEGRAMS]: {
        label: 'labels.telegrams',
        component: TelegramAdapter,
        icon: Email,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF],
        attachmentContentType: ContentType.TELEGRAMS,
    },
    [ButtonType.NOTAMS]: {
        label: 'labels.notice',
        component: NoticeAdapter,
        icon: Notice,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF],
    },
    [ButtonType.CHECK_LIST]: {
        label: 'labels.checkList',
        component: CheckListAdapter,
        icon: CheckList,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF, CrewTypes.PCT_SALONSTAFF],
    },
    [ButtonType.AIRPORT_SERVICE]: {
        label: 'labels.processOperationsShort',
        component: AirportServiceAdapter,
        icon: Service,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF, CrewTypes.PCT_SALONSTAFF],
    },
    [ButtonType.LIMITATIONS]: {
        label: 'labels.limitations',
        component: LimitationAdapter,
        icon: Limitation,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF],
        attachmentContentType: ContentType.LIMITATIONS,
    },
    [ButtonType.DOCUMENTS]: {
        label: 'labels.documents',
        component: DocumentAdapter,
        icon: Document,
        activeTask: true,
        crewLimit: [CrewTypes.PCT_CABINSTAFF, CrewTypes.PCT_SALONSTAFF],
        attachmentContentType: ContentType.DOCUMENTS,
    },
    [ButtonType.ADD_REPORT]: {
        label: 'labels.addReport',
        icon: ReportAdd,
        activeTask: true,
    },
    [ButtonType.REPORTS]: {
        label: 'labels.reports',
        component: ReportAdapter,
        icon: Report,
    },
    [ButtonType.LIBRARY]: {
        label: 'labels.library',
        component: LibraryAdapter,
        icon: Library,
    },
    [ButtonType.SUMMARY_TASK]: {
        label: 'labels.summaryInfo',
        component: SummaryDataAdapter,
        icon: Summary,
        activeTask: true,
    },
    [ButtonType.GET_DATA]: {
        label: 'getData',
        icon: Download,
        activeTask: true,
    },
    [ButtonType.SEND_DATA]: {
        label: 'sendData',
        icon: Send,
        activeTask: true,
    },
    [ButtonType.MESSAGES]: {
        label: 'labels.messages',
        component: MessengerAdapter,
        icon: Comment,
    },
};

export const redirectPages = {
    ['flight-task']: ButtonType.TASKS,
    ['flight']: ButtonType.FLIGHT,
    ['flight-info']: ButtonType.FLIGHT_INFO,
    ['attachments']: ButtonType.TELEGRAMS,
    ['passengers']: ButtonType.PASSENGERS,
    ['crew']: ButtonType.CREW,
    ['airport-service']: ButtonType.AIRPORT_SERVICE,
    ['summary-task']: ButtonType.SUMMARY_TASK,
    ['reports']: ButtonType.REPORTS,
    ['library']: ButtonType.LIBRARY,
    ['messages']: ButtonType.MESSAGES,
};
